import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Button from './Button';

const ConfirmationModal = ({
  buttonVariant = 'ghost',
  body,
  children,
  onCancel,
  onConfirm,
  isBlockScroll = false,
  className,
  buttonAriaLabel = '',
}) => {
  const {
    common: { setHandlers, openModal, closeModal },
  } = useDispatch();

  const bodyDocument = document.querySelector('body');

  const handleCancel = (event) => {
    if (event) {
      event.stopPropagation();
    }
    closeModal();
    if (isBlockScroll) bodyDocument.classList.remove('body-modal-open');
    if (onCancel) onCancel(event);
  };

  const handleConfirm = (event) => {
    if (event) {
      event.stopPropagation();
    }
    closeModal();
    if (isBlockScroll) bodyDocument.classList.remove('body-modal-open');
    onConfirm(event);
  };

  const wrapperClick = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setHandlers({ handleConfirm, handleCancel, body });
    openModal();
    if (isBlockScroll) bodyDocument.classList.add('body-modal-open');
  };

  return (
    <Button
      className={className}
      onClick={wrapperClick}
      variant={buttonVariant}
      aria-label={buttonAriaLabel}
    >
      {children}
    </Button>
  );
};

ConfirmationModal.propTypes = {
  body: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;
